/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingRegionRequest {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingRegionRequest.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingRegionRequest>): AwsSecurityHubFindingRegionRequest {
        let obj = Object.assign(new AwsSecurityHubFindingRegionRequest(), model);
        AwsSecurityHubFindingRegionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingRegionRequest>): AwsSecurityHubFindingRegionRequest {
        if (!model) return null;
        return AwsSecurityHubFindingRegionRequest.newInstance(<AwsSecurityHubFindingRegionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingRegionRequest) {
        if (!obj) return;

        models.AwsSecurityHubFindingRegionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingRegionRequest): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingRegionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Which tenant Id to fetch regions for
     */
    tenant_id: string;

}
